<template>
  <div class="inputRadio --sm --row">
    <label v-for="option of filteredOptions" class="inputRadio__container" :for="option.name">
      <input type="radio"
        class="inputRadio__input"
        :id="option.name"
        :value="option.name"
        v-model="internalValue"
        @change="$emit('change')"
      />
      <span class="inputRadio__checkmark"></span>
      <span class="inputRadio__label">{{ $t(option.label) }}</span>
    </label>
  </div>
</template>

<script>
  import flightTypeMixin from './mixins/mixin-flight-type'
  export default {
    name: 'FlightTypeRadio',
    mixins: [flightTypeMixin]
  }
</script>

<style lang="sass" scoped>
.inputRadio
  margin-bottom: .75rem
  font-size: var(--font-size-base)
  &.--sm
    font-size: var(--font-size-sm)
  &.--row
    display: flex
    align-items: center
    .inputRadio__container
      margin-right: 1rem
  /* The container */
  &__container
    display: flex
    align-items: center
    position: relative
    cursor: pointer
    user-select: none
    min-height: 2rem
    margin: 0
    padding: 0 0.5rem
    border: 1px solid transparent
    border-radius: var(--b-radius-sm)
    transition: background-color .2s ease
    /* On mouse-over if not checked, add a grey background color */
    &:hover
      background-color: var(--color-overlay-05)
      .inputRadio__input:not(:checked) ~ .inputRadio__checkmark
        background-color: var(--color-overlay-20)
        box-shadow: inset 0 0 0 .35rem var(--color-overlay-10)
  /* Hide the browser's default radio button */
  &__input
    position: absolute
    opacity: 0
    cursor: pointer
    /* When the radio button is checked, add a blue background */
    &:checked  ~ .inputRadio__checkmark
      box-shadow: inset 0 0 0 .35rem var(--color-primary)
  /* Create a custom radio button */
  &__checkmark
    height: 1.25rem
    width: 1.25rem
    margin-right: .5rem
    background-color: var(--color-overlay-10)
    border-radius: 50%
    display: inline-block
    transition: background-color .2s ease, box-shadow .2s ease
  // Give label display property
  &__label
    display: block
</style>